import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import { USER_SUCCESS_KEY } from "shared/const/localstorage";

type InitialStateType = {
    isLogin: boolean;
    isLoading: boolean;
    userId:number | null;
};

const storedIsLogin = JSON.parse(localStorage.getItem(USER_SUCCESS_KEY) || 'false');

const initialState: InitialStateType = {
    isLogin: storedIsLogin,
    isLoading: true,
    userId:null,

};

export const accountUserSlice = createSlice({
    name: 'accountUser',
    initialState,
    reducers: {
        accountUser: (state) => {
            const success = localStorage.getItem(USER_SUCCESS_KEY);
            state.isLogin = !!success ?? false;
            state.isLoading = false;
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },

    },
});

export const { actions: accountUserActions  } = accountUserSlice;
export const { reducer: accountUserReducer } = accountUserSlice;
